import React from 'react';
import ReactDOM from 'react-dom';

import AwareCanvas from "./AwareCanvas";

ReactDOM.render(
  <AwareCanvas />, document.getElementById('awarecanvas')
);



// WEBPACK FOOTER //
// ./src/index.js